import AssessorsListPage from "./pages/AssessorsListPage";
import AssessorCreatePage from "./pages/AssessorCreatePage";
import AssessorDetailsPage from "./pages/AssessorDetailsPage";
export const assessorRoutes = [
  {
    path: "/assessors",
    element: <AssessorsListPage />,
    roles: ["admin"],
  },
  {
    path: "/assessors/create",
    element: <AssessorCreatePage />,
    roles: ["admin"],
  },
  {
    path: "/assessors/:id",
    element: <AssessorDetailsPage />,
    roles: ["admin"],
  },
];
